<template>
  <div class="">
    <div class="row">
      <div class="col-md-3 col-12">
        <div class="form-group">
          <label>Type <span class="text-danger">*</span></label>
          <select class="form-select" v-model="scope.type">
            <option>Domain</option>
            <option>IP</option>
            <option>Android</option>
            <option>iOS</option>
          </select>
        </div>
      </div>
      <div class="col-md-9 col-12">
        <label>Identifier <span class="text-danger">*</span></label>
        <input
          type="text"
          class="form-control"
          v-model="scope.identifier"
        />
      </div>
      <div class="col-12 mt-2 mb-2">
        <h4>Is this a production environment?</h4>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="isProd"
            v-model="scope.is_prod"
            value="YES"
          />YES
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="isProd"
            v-model="scope.is_prod"
            value="NO"
            checked
          />
          <label class="form-check-label" for="flexRadioDefault2"> NO </label>
        </div>
      </div>
    </div>
    <div class="col-12 mt-3 text-end">
      <button type="button" class="btn text-white btn-info" v-on:click="save()">
        <span v-if="scope_id > 0">Update</span>
        <span v-else>Save & Continue</span>
      </button>
    </div>
  </div>
</template>
<script>
// import { VueEditor } from "vue2-editor";
export default {
  props: {
    scope_id: Number
  },
  components: {
           // VueEditor
       },
       data() {
        return {
          scope: {
            type: 'Domain',
            identifier: '',
            is_prod: 'NO'
          }
        }
       },
       mounted() {
        if (this.scope_id > 0) {
          this.init();
        }
       },

       methods: {
        init: function() {
          const me = this;
          this.$axios.get(me.$server + 'organisation/' + this.$route.params.org_id + '/project/' + this.$route.params.prod_id + '/scope/' + this.scope_id, {
              params: {
                'description': this.scope_note
              }
            })
              .then(res => {
                if (res.data.success) {
                  this.scope = res.data.data;
                }
            });
        },

        save: function() {
          const me = this;
          if (this.scope_id > 0) {
            this.$axios.put(me.$server + 'organisation/' + this.$route.params.org_id + '/project/' + this.$route.params.prod_id + '/scope/' + this.scope_id, me.scope)
             .then(res => {
                if (res.data.success) {
                  this.$swal({
                    title: res.data.message
                  });

                } else {
                  this.$swal({
                    title: res.data.message,
                    icon: "error"
                  });
                }

                this.$emit('callback', 'updated');
             });
          } else {
             this.$axios.post(me.$server + 'organisation/' + this.$route.params.org_id + '/project/' + this.$route.params.prod_id + '/scope', me.scope)
             .then(res => {
                if (res.data.success) {
                  this.$swal({
                    title: res.data.message
                  });
                  this.$emit('callback', res.data.scope.ID);
                } else {
                  this.$swal({
                    title: res.data.message,
                    icon: "error"
                  });
                }
             });
         }
        this.scope = {
            type: 'Domain',
            identifier: '',
            is_prod: 'NO'
          };
        }

       }
}
</script>
